<template>
    <section class="c-cart-checkout__section">
        <div class="o-grid">
            <div class="o-grid-8" id="billing">
                <div class="c-cart-checkout">
                    <div class="o-form__wrap">
                        <h2 class="c-cart-checkout__title">{{ _t("Facturation") }}</h2>
                        <form ref="checkoutform" @submit.prevent="checkoutSubmit" class="o-form">
                            <div v-if="confirm.message" class="o-form__confirmation"
                                :class="{ '-error': confirm.state == 'error', '-success': confirm.state == 'success' }">
                                <p class="o-form__confirmation__text">{{ confirm.message }}</p>
                            </div>
                            <div class="o-form__row o-grid -x-sm -y-sm">
                                <div class="o-form__group o-grid-6">
                                    <label class="o-label" for="prenom">{{ _t("Prénom") }}</label>
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.first_name }" type="text" id="prenom" name="Prénom" 
                                        v-model="cart.billing_address.first_name" required @change="updateCart">
                                </div>

                                <div class="o-form__group o-grid-6">
                                    <label class="o-label" for="nom">{{ _t("Nom") }}</label>
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.last_name }" type="text" id="nom" name="Nom"
                                        v-model="cart.billing_address.last_name" required @change="updateCart">
                                </div>
                                <!--<PhoneElement
                                    :label="_t('Téléphone')"
                                    name="phone" 
                                    allow-incomplete unmask
                                    rules="required"
                                    :replace-classes="{
                                        ElementLayout:{
                                            container: {
                                                'vf-element-layout': ['o-form__group', 'o-grid-6']
                                            },
                                            outerWrapper: {
                                                'vf-element-layout-outer-wrapper': ''
                                            },
                                            innerContainer: {
                                                'vf-layout-inner-container': '',
                                                'vf-col-12': ''
                                            },
                                        },
                                        PhoneElement:{
                                            input: {
                                                'vf-input-field': 'o-input',
                                            }
                                        },
                                        ElementLabel:{
                                            container:{
                                                'vf-label': 'o-label',

                                            }
                                        }
                                    }"
                                    :default="cart.billing_address.phone"
                                    :placeholder="cart.billing_address.phone"
                                    :floating="false"
                                    @change="cart.billing_address.phone = $event"
                                    />-->
                                <div class="o-form__group o-grid-6">
                                    <label class="o-label" for="courriel">{{ _t("Téléphone") }}</label>
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.phone }" type="phone" id="phone" name="Phone"
                                            v-model="cart.billing_address.phone" required
                                        @change="updateCart">
                                </div>

                                <div class="o-form__group o-grid-6">
                                    <label class="o-label" for="courriel">{{ _t("Courriel") }}</label>
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.email }" type="email" id="courriel" name="Courriel"
                                            v-model="cart.billing_address.email" required
                                        @change="updateCart">
                                </div>
                                
                                <SelectElement
                                    :label="_t('Adresse postale')"
                                    name="address_1"
                                    :object="true"
                                    label-prop="full_address"
                                    value-prop="full_address"
                                    v-model="billing_address"
                                    :resolve-on-load="false"
                                    :delay="0"
                                    :filter-results="false"
                                    :min-chars="2"
                                    :native="false"
                                    :items="getAddresses"
                                    :search="true"
                                    autocomplete="done"
                                    @select="setPlace('billing_address', $event)"
                                    :replace-classes="{
                                        ElementLayout:{
                                            container: {
                                                'vf-element-layout': ['o-form__group', 'o-grid-12']
                                            },
                                            innerWrapper: {
                                                'vf-layout-inner-wrapper': 'o-select__wrap'
                                            },
                                        },
                                        SelectElement:{
                                            inputWrapper: {
                                                'vf-native-select-wrapper': 'o-select__wrap',
                                            },
                                            select: {
                                                search:{
                                                    'vf-multiselect-search': 'o-select'
                                                }
                                            },
                                            input: {
                                                'vf-input': 'o-select',
                                            }
                                        },
                                        ElementLabel:{
                                            container:{
                                                'vf-label': 'o-label',

                                            }
                                        }
                                    }"
                                    :no-options-text="_t('Aucune adresse trouvée')"
                                    :placeholder="cart.billing_address.address_1"
                                    :floating="false"
                                    :remove-classes="{
                                        ElementLayout:{
                                            innerContainer: ['vf-layout-inner-container'],
                                            outerWrapper: ['vf-element-layout-outer-wrapper']
                                        }
                                    }"
                                    >
                                    <template v-slot:single-label="{ value }">
                                        <div class="vf-multiselect-single-label">
                                            <div class="vf-multiselect-single-label__text">{{ value.address_1 }}</div>
                                        </div>
                                    </template>
                                    <template v-slot:option="{ option }">
                                        <div class="vf-multiselect-option">
                                            <div class="vf-multiselect-option__text">{{ option.full_address }}</div>
                                        </div>
                                    </template>
                                    <template v-slot:no-options>
                                        <ul class="vf-multiselect-options">
                                            <li class="vf-multiselect-option">
                                                <div class="vf-multiselect-option">
                                                    <div class="vf-multiselect-option__text">{{ _t('Aucune adresse trouvée') }}</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </template>
                                </SelectElement>
                                <input type="hidden" name="address_1" v-model="cart.billing_address.address_1">

                                <div class="o-form__group o-grid-12">
                                    <label class="o-label" for="address_2">{{ _t("Complément d'adresse") }}</label>
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.address_2 }" type="text" id="address_2" name="Ville"
                                            v-model="cart.billing_address.address_2"
                                        @change="updateCart">
                                </div>

                                <div class="o-form__group o-grid-12">
                                    <label class="o-label" for="ville">{{ _t("Ville") }}</label>
                                    <input class="o-input" type="text" id="ville" name="Ville" 
                                        :class="{'-input-filled' : cart.billing_address.city }"
                                        v-model="cart.billing_address.city" required @change="updateCart"> 
                                </div>

                                <div class="o-form__group o-grid-12">
                                    <label class="o-label" for="pays">{{ _t("Pays") }}</label>
                                    <div class="o-select__wrap">
                                        <select class="o-select" id="pays" name="Pays"
                                            v-model="cart.billing_address.country" required @change="updateCart">
                                            <option value="" disabled selected>{{ _t("Pays") }}</option>
                                            <option v-for="country in countries" :value="country.iso2" :key="country.iso2">{{ country.name }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="o-form__group o-grid-6">
                                    <label class="o-label" for="province">{{ _t("Province") }}</label>
                                    <div class="o-select__wrap">
                                        <select class="o-select" id="province" name="Province"
                                            v-model="cart.billing_address.state" required @change="updateCart">
                                            <option value="" disabled selected>{{ _t("Province") }}</option>
                                            <template v-if="cart.billing_address.country && countries.find(country => country.iso2 == cart.billing_address.country)">
                                                <option v-for="(state, key) in countries.find(country => country.iso2 == cart.billing_address.country).states" :key="key" :value="state.state_code">{{ state.name }}</option>
                                            </template>
                                        </select>
                                    </div>
                                </div>

                                <div class="o-form__group o-grid-6">
                                    <label class="o-label" for="code_postal">{{ _t("Code postal") }}</label>
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.postcode }" type="text" id="code_postal" name="Code postal"
                                            v-model="cart.billing_address.postcode" required
                                        @change="updateCart">
                                </div>

                                <!--Adresse de facturation est la même que la livraison-->
                                <div class="o-form__group o-grid-12">
                                    <div class="o-form-group o-checkbox__group">
                                        <div class="o-checkbox__wrap">
                                            <input class="o-checkbox" type="checkbox" id="not_same_address" name="not_same_address" v-model="cart.not_same_address"
                                                @change="updateCart">
                                            <label class="o-checkbox-label" for="not_same_address">
                                                {{ _t("Mon adresse de facturation est différente de mon adresse de livraison") }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="cart.not_same_address == true">
                                    <SelectElement
                                        :label="_t('Adresse de livraison')"
                                        name="address_1"
                                        :object="true"
                                        label-prop="full_address"
                                        value-prop="full_address"
                                        v-model="shipping_address"
                                        :resolve-on-load="false"
                                        :delay="0"
                                        :filter-results="false"
                                        :min-chars="2"
                                        :native="false"
                                        autocomplete="done"
                                        @select="setPlace('shipping_address', $event)"
                                        :items="getAddresses"
                                        :search="true"
                                        :replace-classes="{
                                            ElementLayout:{
                                                container: {
                                                    'vf-element-layout': ['o-form__group', 'o-grid-12']
                                                },
                                                innerWrapper: {
                                                    'vf-layout-inner-wrapper': 'o-select__wrap'
                                                },
                                            },
                                            SelectElement:{
                                                inputWrapper: {
                                                    'vf-native-select-wrapper': 'o-select__wrap',
                                                },
                                                select: {
                                                    search:{
                                                        'vf-multiselect-search': 'o-select'
                                                    }
                                                },
                                                input: {
                                                    'vf-input': 'o-select',
                                                }
                                            },
                                            ElementLabel:{
                                                container:{
                                                    'vf-label': 'o-label',

                                                }
                                            }
                                        }"
                                        :no-options-text="_t('Aucune adresse trouvée')"
                                        :placeholder="cart.shipping_address.address_1"
                                        :floating="false"
                                        :remove-classes="{
                                            ElementLayout:{
                                                innerContainer: ['vf-layout-inner-container'],
                                                outerWrapper: ['vf-element-layout-outer-wrapper']
                                            }
                                        }"
                                        >
                                        <template v-slot:single-label="{ value }">
                                            <div class="vf-multiselect-single-label">
                                                <div class="vf-multiselect-single-label__text">{{ value.address_1 }}</div>
                                            </div>
                                        </template>
                                        <template v-slot:option="{ option }">
                                            <div class="vf-multiselect-option">
                                                <div class="vf-multiselect-option__text">{{ option.full_address }}</div>
                                            </div>
                                        </template>
                                        <template v-slot:no-options>
                                            <ul class="vf-multiselect-options">
                                                <li class="vf-multiselect-option">
                                                    <div class="vf-multiselect-option">
                                                        <div class="vf-multiselect-option__text">{{ _t('Aucune adresse trouvée') }}</div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </template>
                                    </SelectElement>

                                    <div class="o-form__group o-grid-12">
                                        <label class="o-label" for="address_2">{{ _t("Complément d'adresse") }}</label>
                                        <input class="o-input" :class="{'-input-filled' : cart.shipping_address.address_2 }" type="text" id="address_2" name="Ville"
                                                v-model="cart.shipping_address.address_2"
                                            @change="updateCart">
                                    </div>

                                    <div class="o-form__group o-grid-12">
                                        <label class="o-label" for="ville">{{ _t("Ville") }}</label>
                                        <input class="o-input" type="text" id="ville" name="Ville" 
                                            :class="{'-input-filled' : cart.shipping_address.city }"
                                            v-model="cart.shipping_address.city" required @change="updateCart">
                                    </div>

                                    <div class="o-form__group o-grid-12">
                                        <label class="o-label" for="pays">{{ _t("Pays") }}</label>
                                        <div class="o-select__wrap">
                                            <select class="o-select" id="pays" name="Pays"
                                                v-model="cart.shipping_address.country" required @change="updateCart">
                                                <option value="" disabled selected>{{ _t("Pays") }}</option>
                                                <option v-for="country in countries" :value="country.iso2" :key="country.iso2">{{ country.name }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="o-form__group o-grid-6">
                                        <label class="o-label" for="province">{{ _t("Province") }}</label>
                                        <div class="o-select__wrap">
                                            <select class="o-select" id="province" name="Province"
                                                v-model="cart.shipping_address.state" required @change="updateCart">
                                                <option value="" disabled selected>{{ _t("Province") }}</option>
                                                <template v-if="cart.shipping_address.country && countries.find(country => country.iso2 == cart.shipping_address.country)">
                                                    <option v-for="(state, key) in countries.find(country => country.iso2 == cart.shipping_address.country).states" :key="key" :value="state.state_code">{{ state.name }}</option>
                                                </template>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="o-form__group o-grid-6">
                                        <label class="o-label" for="code_postal">{{ _t("Code postal") }}</label>
                                        <input class="o-input" :class="{'-input-filled' : cart.shipping_address.postcode }" type="text" id="code_postal" name="Code postal"
                                                v-model="cart.shipping_address.postcode" required
                                            @change="updateCart">
                                    </div>
                                </template>
                            </div>
                        </form>
                        <div v-if="cart.discounts" class="c-cart-checkout__discounts">
                            <div v-for="discount in cart.discounts" :key="discount.id" class="c-cart-checkout__discounts__item">
                                <p>{{ discount.name }}</p>
                                <p class="c-cart-checkout__amount">{{ formatMoney(discount.amount) }}</p>
                                <span @click="removeDiscount(discount.id, $event)">{{ _t("Supprimer") }}</span>
                            </div>
                        </div>
                        <div class="o-button__container c-cart-checkout__btn">
                            <div v-if="!isEmpty(cart.items) && addingDiscount == false  && showDiscounts" class="o-form__button">
                                <button class="o-button  o-button-cart" type="button" @click="addingDiscount = true">
                                    <span class="o-button__text">{{ _t("Ajouter une remise") }}</span>
                                    <span class="sr-only">{{ _t("Ajouter une remise") }}</span>
                                    <svg class="o-ico -icon-arrow-full-right" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                                    </svg>
                                </button>
                            </div>

                            <form class="o-form" @submit.prevent="addDiscount()" v-if="!isEmpty(cart.items) && addingDiscount == true">
                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : discountCode }" type="text" id="discount" name="Code de remise"
                                        v-model="discountCode" required>
                                    <label class="o-label" for="discount">{{ _t("Code de remise") }}</label>
                                </div>
                                <div class="o-form__button o-button__container">
                                    <button class="o-button  o-button-cart" type="submit">
                                        <span class="o-button__text">{{ _t("Ajouter") }}</span>
                                        <span class="sr-only">{{ _t("Ajouter") }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="o-ico -icon-arrow-full-right">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </button>
                                    <button class="o-button  o-button-cart" type="button" @click="addingDiscount = false">
                                        <span class="o-button__text">{{ _t("Annuler") }}</span>
                                        <span class="sr-only">{{ _t("Annuler") }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="o-ico -icon-arrow-full-right">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-grid-4" :class="{ 'is-loading': loadingSummarize }" id="billing-resume">
                <h2 class="c-cart-checkout__title">
                    {{ _t("Votre commande") }}
                </h2>
                <!--Product lists with price-->
                <div class="c-cart-checkout">
                    <div v-if="!isEmpty(cart.items)" class="o-form__wrap">
                        <div class="c-cart-checkout__items">
                            <div class="c-cart-checkout__row" v-for="item in cart.items" :key="item.product_id">
                                <div v-if="item.type != 'cdj'" class="c-cart-checkout__row__inner">
                                    <div class="c-cart-checkout__img">
                                        <img :src="item.image" :alt="item.name">
                                    </div>
                                    <p class="c-cart-checkout__label">{{ item.name }} (x{{ item.quantity }})</p>
                                    <!-- <p class="c-cart-checkout__description" v-if="item.description">{{ item.description }}</p> -->
                                </div>
                                <div v-else class="c-cart-checkout__row__inner">
                                    <div class="c-cart-checkout__img">
                                        <img :src="item.image" :alt="item.name">
                                    </div>
                                    <p class="c-cart-checkout__label">{{ item.name }}</p>
                                    <!-- <p class="c-cart-checkout__description" v-if="item.description">{{ item.metadata.first_name }} {{ item.metadata.last_name }}</p> -->
                                </div>
                                <div class="">
                                    <p class="c-cart-checkout__amount">{{ formatMoney(item.total) }}</p>
                                </div>
                            </div>
                            <div class="c-cart-checkout__row" v-if="showDiscounts && cart.discountTotal">
                                <div class="">
                                    <p class="c-cart-checkout__label">{{ _t("Remises") }}</p>
                                </div>
                                <div class="">
                                    <p class="c-cart-checkout__amount">{{ formatMoney(cart.discountTotal) }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="c-cart-checkout__total">
                            <div class="c-cart-checkout__row">
                                <div class="">
                                    <p class="c-cart-checkout__label">{{ _t("Sous-total") }}</p>
                                </div>
                                <div class="">
                                    <p class="c-cart-checkout__amount">{{ formatMoney(cart.subtotal) }}</p>
                                </div>
                            </div>
                            <template v-if="showTaxes">
                                <template v-if="cart.billing_address.country != ''">
                                    <div class="c-cart-checkout__row" v-for="tax in cart.taxes" :key="tax.name">
                                        <div class="">
                                            <p class="c-cart-checkout__label">{{ tax.name }}</p>
                                        </div>
                                        <div class="">
                                            <p class="c-cart-checkout__taxes">{{ formatMoney(tax.amount) }}</p>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="c-cart-checkout__row">
                                        <div class="">
                                            <p class="c-cart-checkout__label">{{ _t("Taxes") }}</p>
                                        </div>
                                        <div class="">
                                            <p class="c-cart-checkout__taxes">{{ _t("Entrer votre adresse pour calculer les taxes") }}</p>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <div class="c-cart-checkout__row">
                                <div class="">
                                    <p class="c-cart-checkout__label">{{ _t("Total") }}</p>
                                </div>
                                <div class="">
                                    <p class="c-cart-checkout__amount">{{ formatMoney(cart.total) }} {{ currency }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="c-cart-checkout">
                            <div class="o-form__wrap">
                                <p>{{ _t("Votre panier est vide") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="o-button__container c-cart-checkout__btn">
                    <div v-if="!isEmpty(cart.items)" class="">
                        <button class="o-button o-button-cart -button-filled" type="submit" :class="{ loadingCheckout: 'is-loading' }"
                            @click="$refs.checkoutform.requestSubmit()"
                            :disabled="loadingCheckout">
                            <span class="o-button__text">{{ _t("Passer au paiement") }}</span>
                            <svg v-if="!loadingCheckout" aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#pay"></use>
                            </svg> 
                            <svg v-else aria-hidden="true" focusable="false" class="o-ico -icon-spinner">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#spinner"></use>
                            </svg>
                        </button>
                    </div>

                    <button class="o-button" @click="modify()">
                        <span class="o-button__text">{{ _t("Modifier mon panier") }}</span>
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#cart"></use>
                        </svg> 
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
import { Vueform, useVueform } from '@vueform/vueform'
//import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
//app.config.globalProperties._t = app._component.methods.translateString

export default {
    name: 'ProductCart',
    mixins: [Vueform],
    setup: useVueform,
    data() {
        //const _t = this.$root.translateString
        return {
            cart: {
                billing_address: {},
                shipping_address: {},
            },
            token: null,
            loadingSummarize: false,
            loadingCheckout: false,
            confirm: {
                message: '',
                state: ''
            },
            billing_address: {},
            shipping_address: {},
            currency: window.ajax_var.currency,
            addingDiscount: false,
            discountCode: '',
            showDiscounts: window.ajax_var.showDiscounts,
            showTaxes: window.ajax_var.showTaxes,
            pages: window.ajax_var.pages,
            countries: []
        }
    },
    components: {
        //MazPhoneNumberInput,
    },
    methods: {
        async getAddresses(q){
            let params = {
                _wpnonce: window.ajax_var.nonce,
                address: q
            }

            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce

            let response = await axios.get('/wp-json/stereostore/v1/addresses', { params })
            return response.data
        },
        async getCart(first=false) {
            this.loadingSummarize = true
            if (!this.$store.state.token) {
                //Redirect to home page
                location.href = '/'
            }
            this.token = this.$store.state.token

            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                rand : Math.random()
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            await axios.get('/wp-json/stereostore/v1/cart', { params })
                .then(response => {
                    response.data.data.items.forEach(item => {
                        if (item.type == 'cjd') {
                            item.metadata = JSON.parse(item.metadata)
                        }
                    });
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    this.loadingSummarize = false
                    if(first){
                        try {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'begin_checkout',
                                'ecommerce': {
                                    'currency': window.ajax_var.currency,
                                    'items': this.cart.items.map(item => {
                                        return {
                                            'id': item.product_id,
                                            'name': item.name,
                                            'price': item.price,
                                            'quantity': item.quantity,
                                            'variant': item.sku
                                        }
                                    })
                                }
                            });
                        }catch(e){
                            console.log(e)
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })

            return this.cart
        },
        formatMoney(value) {
            let language = window.ajax_var.currentLang;
            let currency = window.ajax_var.currency;
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
        calculateTaxes() {
            let taxes = this.cart.taxes
            let total = 0
            for (let i = 0; i < taxes.length; i++) {
                total += taxes[i].amount
            }
            return this.formatMoney(total)
        },
        checkout() {
            location.href = this.pages.checkout
        },
        modify() {
            location.href = this.pages.cart
        },
        isEmpty(array) {
            return !Array.isArray(array) || !array.length
        },
        setPlace(where, place) {
            this.cart[where].address_1 = place.address_1
            this.cart[where].city = place.city
            this.cart[where].state = place.state
            this.cart[where].postcode = place.postcode
            this.cart[where].country = place.country
            try{
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'add_shipping_info',
                    'ecommerce': {
                        'currency': window.ajax_var.currency,
                        'items': this.cart.items.map(item => {
                            return {
                                'id': item.product_id,
                                'name': item.name,
                                'price': item.price,
                                'quantity': item.quantity,
                                'variant': item.sku
                            }
                        })
                    }
                    
                });
            }catch(e){
                console.log(e)
            }
            this.updateCart()
        },
        async updateCart() {
            if(!this.cart.token) await this.getCart();
            this.loadingSummarize = true
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                cart: this.cart
            }
            //if state is not in country, reset state
            if (this.cart.billing_address.country) {
                if (!this.countries.find(country => country.iso2 == this.cart.billing_address.country).states.find(state => state.state_code == this.cart.billing_address.state)) {
                    this.cart.billing_address.state = ''
                }
            }
            if (this.cart.shipping_address.country) {
                if (!this.countries.find(country => country.iso2 == this.cart.shipping_address.country).states.find(state => state.state_code == this.cart.shipping_address.state)) {
                    this.cart.shipping_address.state = ''
                }
            }

            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.put('/wp-json/stereostore/v1/cart', params)
                .then(response => {
                    this.loadingSummarize = false
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    //document.getElementById('stereostore-add').setAttribute('autocomplete', 'new-password')
                })
                .catch(error => {
                    console.log(error)
                })
        },
        /*updateAutoComplete() {
            //Set timeout to avoid conflict with google maps autocomplete
            setTimeout(() => {
                if (document.getElementById('stereostore-add') ) document.getElementById('stereostore-add').setAttribute('autocomplete', 'new-password')
            }, 1000)
        },*/
        checkoutSubmit() {
            this.loadingCheckout = true
            if(this.validateForm() == false) {
                this.loadingCheckout = false
                return
            }
            //Check if cart is empty
            if (this.isEmpty(this.cart.items)) {
                alert('Votre panier est vide.')
                this.loadingCheckout = false
                return
            }

            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                rand : Math.floor(Math.random() * 1000000)
            }

            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.get('/wp-json/stereostore/v1/cart/checkout', { params })
                .then(response => {
                    this.confirm = {
                        state: 'success',
                        message: response.data.message
                    }
                    //Redirect to payment gateway
                    location.href = response.data.data.url

                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                    this.loadingCheckout = false
                })

        },
        validateForm(){
            let valid = true
            let error = ''
            if(this.cart.billing_address.first_name == '') {
                error = 'Veuillez entrer votre prénom'
                valid = false
            }
            if(this.cart.billing_address.last_name == '') {
                error = 'Veuillez entrer votre nom'
                valid = false
            }
            if(this.cart.billing_address.phone == '') {
                error = 'Veuillez entrer votre numéro de téléphone'
                valid = false
            }
            if(this.cart.billing_address.email == '') {
                error = 'Veuillez entrer votre courriel'
                valid = false
            }
            if(this.cart.billing_address.address_1 == '') {
                error = 'Veuillez entrer votre adresse'
                valid = false
            }
            if(this.cart.billing_address.city == '') {
                error = 'Veuillez entrer votre ville'
                valid = false
            }
            if(this.cart.billing_address.state == '') {
                error = 'Veuillez entrer votre province'
                valid = false
            }
            if(this.cart.billing_address.postcode == '') {
                error = 'Veuillez entrer votre code postal'
                valid = false
            }
            if(!valid) {
                this.confirm = {
                    state: 'error',
                    message: error
                }
            }

            return valid
        },
        addDiscount() {
            this.confirm = {
                message: '',
                state: ''
            };
            this.loadingSummarize = true
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                code: this.discountCode
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.post('/wp-json/stereostore/v1/cart/discount', params)
                .then(response => {
                    this.loadingSummarize = false
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    this.addingDiscount = false
                    this.discountCode = ''
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                    this.loadingSummarize = false
                })
        },
        removeDiscount(id, event){
            this.confirm = {
                message: '',
                state: ''
            };
            event.preventDefault()
            this.loadingSummarize = true
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                id: id
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.delete('/wp-json/stereostore/v1/cart/discount', { params })
                .then(response => {
                    this.loadingSummarize = false
                    this.cart = response.data.data
                    this.token = response.data.data.token
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                    this.loadingSummarize = false
                })
        }
    },
    mounted() {
        fetch('/app/uploads/countries_regions.json')
        .then(response => response.json())
        .then(data => {
            this.countries = data
            //if currency is cad the only country propose is canada
            if (this.currency == 'CAD') {
                this.countries = this.countries.filter(country => country.iso2 == 'CA')
            }
        })
        
        this.getCart(true);
        //this.updateAutoComplete()
    },
}
</script>